import React from 'react';
import { Router } from '@reach/router';

import Dashboard from './Dashboard';
import UsedLinks from './UsedLinks';
import Container from './Container';

export default () => (
  <Container>
    <Router>
      <Dashboard path="/*" />
      <UsedLinks path="used_links/*" />
    </Router>
  </Container>
);
